<template>
  <div class="card">
    <div
      class="packshot"
    >
      <div class="packshot__background decoration-pattern-nuage" />

      <div :class="['packshot__pic', product.packshot]" />

      <div class="packshot__title decoration-bloc-titre">
        {{ product.title }}
      </div>
    </div>

    <ProductInjectedContent
      class="content"
      :product="product"
    />
  </div>
</template>

<script>
import ProductInjectedContent from '@/components/products/ProductInjectedContent.vue';

export default {
  components: {
    ProductInjectedContent,
  },

  props: {
    product: { type: Object, required: true },
  },
};
</script>

<style lang="stylus" scoped>
.card {
  padding-top: 20px;
}

.packshot {
  position: relative;
  display: flex;
  align-items: flex-end;

  height: 240px;

  &__background {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 30px;
    left: 0;
    z-index: 0;

    width: 100%;
    height: auto;

    background-repeat: repeat;
    border-radius: 30px;
    border: 2px solid black;
  }

  &__pic {
    position: relative;
    z-index: 1;

    margin: 0 auto;
  }

  &__title {
    @extends $roll;

    position: absolute;
    top: 0;
    left: 30px;
    z-index: 2;
  }
}

.content {
  padding-top: 25px;
}
</style>
